import { styled } from '@mui/material/styles';
import { TableCell, TableRow } from '@mui/material';

import { FORTA_BLUE } from '../../../../../../utils/colors';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:first-of-type': {
    borderRight: 'none',
  },
  '&:last-child': {
    textAlign: 'left',
    paddingLeft: 16,
  },
  padding: 1.5,
  position: 'relative',
  textAlign: 'center',
  fontSize: 16,
  height: 40,
  '&:nth-of-type(2)': {
    color: FORTA_BLUE.primary,
    fontWeight: 700,
    borderLeft: 'none',
  },
  '&.MuiTableCell-head': {
    backgroundColor: FORTA_BLUE.light3,
    color: FORTA_BLUE.primary,
    fontWeight: 700,
    '&:last-child': {
      paddingLeft: 16,
    },
  },
}));

export const StageIndicator = styled('div')(({ color = '#000' }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: color,
  margin: '0 auto',
}));

export const StageArrow = styled('div')<{
  color?: string;
  direction: 'forward' | 'backward';
  stageCount?: number;
}>(({ color = '#000', direction, stageCount = 1 }) => ({
  position: 'absolute',
  top: '50%',
  left: direction === 'forward' ? '50%' : `${-50 * (2 * stageCount - 1)}%`,
  width: `${100 * stageCount}%`,
  height: 2,
  backgroundColor: color,
  transform: direction === 'forward' ? 'translateY(-50%)' : 'translateY(-50%) rotate(180deg)',
  zIndex: 1,
  '&::after': {
    content: '""',
    position: 'absolute',
    right: -6,
    top: -4,
    width: 0,
    height: 0,
    borderLeft: `6px solid ${color}`,
    borderTop: `5px solid transparent`,
    borderBottom: `5px solid transparent`,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
